import { mapActions } from 'vuex'
import { dateToShow, dateToMysql } from '@/helpers/dates'
import { get, map, find } from 'lodash'
import { userType } from './dataType'
import bus from '@/utils/eventBus'
import moment from 'moment'

// import { isEmpty } from 'lodash'
import { success } from '@/utils/alert'

const dtToday = () => {
  let isNow = new Date()
  let month = isNow.getMonth() + 1
  let day = isNow.getDate()
  let today = isNow.getFullYear() + '-' + (('' + month).length < 2 ? '0' : '') + month + '-' + (('' + day).length < 2 ? '0' : '') + day
  return today
}

const dtTodayMoreOne = () => {
  let beforedate = new Date()
  let priordate = new Date()
  priordate.setDate(beforedate.getDate() + 1)
  let dd2 = priordate.getDate()
  let mm2 = priordate.getMonth() + 1
  let yyyy2 = priordate.getFullYear()
  if (dd2 < 10) { dd2 = '0' + dd2 };
  if (mm2 < 10) { mm2 = '0' + mm2 };
  let datefrommonthago = yyyy2 + '-' + mm2 + '-' + dd2

  return datefrommonthago
}

const prepareSave = profile => {
  if (profile.birthdate === 'Invalid date') {
    profile.birthdate = '1900-01-01'
  } else {
    profile.birthdate = dateToMysql(profile.birthdate)
  }

  if (profile.state === null) {
    delete profile.state
  }

  return profile
}

const prepareShow = profile => {
  profile.birthdate = dateToShow(profile.birthdate)
  return profile
}

export default {
  ...mapActions(['updateUserData', 'logout', 'userIsProfessional', 'userIsCompany']),
  doSave () {
    this.$v.$touch()
    this.$nextTick(() => this.focusFirstStatus())

    if (this.$v.$error) {
      return
    }

    const profile = prepareSave({...this.profile})

    this.$resource.update('me', profile)
      .then(({data}) => {
        const user = {...data}
        user.avatar = user.avatar + '?' + new Date()
        this.updateUserData(user)
        this.show = true

        success('Seu dados foram alterados com sucesso.')
      })
      .catch(({data}) => {
        this.errors = data
      })
  },
  doSaveSchedule () {
    this.$v.$touch()
    this.$nextTick(() => this.focusFirstStatus())
    if (this.$v.$error) {
      return
    }

    const params = {
      event_name: this.schedule.event_name,
      title: this.schedule.event_name,
      tower_id: this.schedule.tower_id,
      unit_id: this.schedule.unit_id,
      dweller_guest_list_id: this.schedule.dweller_guest_list_id,
      color: '#' + Math.floor(Math.random() * 16777215).toString(16),
      go_in: this.schedule.go_in
    }
    this.loading = true
    this.$http.put(`/v1/dweller/commom-area/schedules/${this.schedule.id}`, params)
      .then(({data}) => {
        if (this.charge_for_hours) {
          bus.$emit('do-created-schedule', {show: true})
          this.$toast.success('Seu agendamneto foi confirmado com sucesso.')
          this.$nextTick(() => { this.$v.$reset() })
          this.loading = false
          this.schedule = {
            id: null,
            event_name: null,
            title: null,
            start_date: null,
            end_date: null,
            tower_id: null,
            unit_id: null,
            dweller_guest_list_id: null,
            go_in: null,
            go_out: null
          }
          this.area_id = null
          this.id_common_area = null
          this.scheduleTimes = []
          this.prevRestart()
          this.minDt = dtTodayMoreOne()
          this.doHide()
        } else {
          bus.$emit('do-created-schedule', {show: true})
          this.$toast.success('Seu agendamneto foi confirmado com sucesso.')
          this.$nextTick(() => { this.$v.$reset() })
          this.loading = false
          this.schedule = {
            id: null,
            event_name: null,
            title: null,
            start_date: null,
            end_date: null,
            tower_id: null,
            unit_id: null,
            dweller_guest_list_id: null,
            go_in: null,
            go_out: null
          }
          this.area_id = null
          this.id_common_area = null
          this.scheduleTimes = []
          this.prevRestart()
          this.doHide()
        }
      })
      .catch(({data}) => {
        this.errors = data
      })
  },
  doLoad () {
    this.$resource.get('/me')
      .then(({data}) => {
        this.profile = prepareShow({...data})
      })
  },
  onUploadedAvatar (response) {
    if (!response) {
      return
    }
    // this.showModal = false
    const user = {...response}
    user.image = user.image
    if (this.user.image_required === 'true') {
      user.image_required = 'false'
    }
    this.updateUserData(user)
  },
  doToggleModal (value) {
    this.showModal = value
  },
  focusFirstStatus (component = this) {
    if (component.status) {
      component.$el.focus()
      return true
    }

    let focused = false

    component.$children.some((childComponent) => {
      focused = this.focusFirstStatus(childComponent)
      return focused
    })

    return focused
  },

  doLogout () {
    const isProfessional = (user) => {
      return user.type === 'professional'
    }
    const isCompany = (user) => {
      return user.type === 'company'
    }
    this.logout()
      .then(() => {
        if (isProfessional(this.user)) {
          return this.$router.push({name: 'auth.professional.login'})
        }

        if (isCompany(this.user)) {
          return this.$router.push({name: 'auth.company.login'})
        }

        window.location.href = '/'
      })
  },
  getPassword (password) {
    this.showModalPassword = true
    this.isPassword = true
  },
  closePassword () {
    this.isPassword = false
    this.showModalPassword = false
  },
  doShow () {
    this.isShowing = true
    this.getDwellerGuestList()
    this.schedule = {
      event_name: null,
      title: null,
      start_date: null,
      end_date: null,
      tower_id: null,
      unit_id: null,
      dweller_guest_list_id: null,
      common_area_id: null
    }
  },
  doHide () {
    this.isShowing = false
    this.$nextTick(() => { this.$v.$reset() })
  },
  doHideCovids () {
    this.isCovids = false
  },
  getTypeUser () {
    return get(userType, this.user.type, this.user.type)
  },
  getCommonArea () {
    this.$http.get('/v1/dweller/commun/area')
    .then(({data}) => {
      const area = map(data, function (item) {
        return {
          id: item.id,
          label: item.name,
          daily_limit: item.daily_limit
        }
      })
      this.commonAreaOptions = area
    })
  },
  getCommonAreaById (id) {
    this.loading = true
    this.$http.get(`/v1/dweller/commun/area/${id}`)
    .then(({data}) => {
      this.loading = false
      if (data.charge_for_hours === 'true') {
        this.dwellerGuestListOptions = []
        this.charge_for_hours = true
      } else {
        this.charge_for_hours = false
      }
    })
  },
  getCommonAreaScheduled (area) {
    this.loading = true
    const params = {
      go_in: dtToday(),
      common_area_id: area,
      tower_id: this.schedule.tower_id,
      unit_id: this.schedule.unit_id
    }
    this.$http.post(`/v1/dweller/search/scheduled`, params)
    .then((data) => {
      if (data === 1) {
        bus.$emit('exist-events-common-area', {status: true})
        this.$toast.error('Já existe uma reserva para esta unidade nesta data.')
        this.loading = false
      } else {
        this.loading = false
        bus.$emit('exist-events-common-area', {status: false})
      }
      this.loading = false
    })
  },
  selectEvents (area) {
    bus.$emit('get-events-common-area', {id: area})
  },
  /** horarios para agendamentos */
  selectTimesCommomArea (dt) {
    /** se a area comum nao for por hora */
    if (!this.charge_for_hours) {
      const params = {
        dt_start: dt,
        common_area_id: this.area_id
      }
      this.loading = true
      this.$http.post(`/v1/dweller/search/scheduled/day`, params)
      .then(({data}) => {
        this.loading = false
        if (data.length === 0) {
          this.$toast.error('Esta data não esta mais disponivel.')
          this.loading = false
          this.scheduleByDay = false
          this.schedule.id = null
        } else {
          this.availableDay = data
          this.scheduleByDay = true
          this.schedule.id = data[0].id
        }
      })
    } else {
      const params = {
        dt_start: dt,
        area_id: this.id_common_area
      }
      this.schedule.common_area_id = this.area_id
      this.schedule = {
        id: null,
        event_name: null,
        title: null,
        tower_id: this.schedule.tower_id,
        unit_id: this.schedule.unit_id,
        start_date: null,
        end_date: null,
        dweller_guest_list_id: null,
        common_area_id: null,
        go_in: null,
        go_out: null
      }
      this.loading = true
      this.$http.post(`/v1/dweller/search/schedule/times`, params)
      .then(({data}) => {
        this.loading = false
        if (data.length) {
          const times = map(data, (item) => {
            return {
              id: item.id,
              time: moment(item.dt).format('HH:mm')
            }
          })
          this.schedule.go_in = dt
          this.scheduleTimes = times
          this.loading = false
          this.prevRestart()
        } else {
          this.scheduleTimes = []
          this.loading = false
          this.prevRestart()
        }
      })
    }
  },
  selectDates (area) {
    this.getCommonAreaById(area)
    // tratando horarios para quadra esportivas OHIO
    if (this.id_common_area === area) {
      this.options = this.timeOptionsQuadra
    } else {
      this.options = this.timeOptions
    }
    if (area) {
      this.loading = true
      this.$http.get('/v1/dweller/schedules/' + area)
      .then((data) => {
        if (data.length >= 1) {
          console.log(data)
          const dts = map(data, (item) => {
            return moment(item.start_date, 'YYYYMMDD').format('YYYY-MM-DD')
          })
          this.dates = dts
          this.loading = false
        } else {
          this.dates = []
          this.loading = false
        }
      }).catch(({data}) => {

      })
    }
  },
  getDwellerGuestList () {
    this.$http.get('/v1/dweller/guest/list')
      .then(({data}) => {
        // nao sei por que esta aqui
        // if (data.length === 0) {
        //   this.charge_for_hours = true
        // }
        const towers = map(data, function (item) {
          return {
            id: item.id,
            name: item.name
          }
        })
        this.dwellerGuestListOptions = towers
      })
  },
  getTowersDweller () {
    this.loading = true
    this.$http.get('/v1/dweller/towers/search')
      .then(({data}) => {
        const towers = map(data, function (item) {
          return {
            id: item.id,
            number: item.number + ' - ' + item.name
          }
        })
        this.dwellerTowers = towers
        this.schedule.tower_id = this.dwellerTowers[0].id
        this.loading = false
        this.selectUnitsTowerAuto(this.schedule.tower_id)
      })
  },
  /** Retornando as unidades da torre selecionada */
  selectUnitsTowerAuto (tower) {
    this.loading = true
    if (typeof tower === 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower.id)
      .then(({data}) => {
        this.dwellerUnits = data
        this.schedule.unit_id = this.dwellerUnits[0].id
        this.loading = false
        if (this.area_id !== null) {
          this.setCommomAreaId(this.area_id)
        }
      })
    }

    if (typeof tower !== 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower)
      .then(({data}) => {
        this.dwellerUnits = data
        this.schedule.unit_id = this.dwellerUnits[0].id
        this.loading = false
        if (this.area_id !== null) {
          this.setCommomAreaId(this.area_id)
        }
      })
    }
  },
  /** Retornando as unidades da torre selecionada */
  selectUnitsTower (tower) {
    this.loading = true
    if (typeof tower === 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower.id)
      .then(({data}) => {
        this.dwellerUnits = data
        this.loading = false
      })
    }

    if (typeof tower !== 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower)
      .then(({data}) => {
        this.dwellerUnits = data
        this.loading = false
      })
    }
  },
  createList (show) {
    if (show) {
      this.isShow = show
    }
    if (!show) {
      this.isShow = !show
    }
  },
  doSaveNameList () {
    this.$http.post('/v1/dweller/guest/list', this.guest)
    .then((data) => {
      if (data.id) {
        this.isShow = true
        this.guest_list_id = data.id
        this.getDwellerGuestList()
      }
    })
  },
  doSaveList () {
    this.$v.$touch()
    if (this.$v.$error) {
      return
    }

    const params = {
      name: this.person.name,
      dweller_guest_list_id: this.person.dweller_guest_list_id
    }
    this.loading = true
    this.$http.post('/v1/dweller/guest/list/person', params)
      .then((data) => {
        if (data.id) {
          this.$nextTick(() => { this.$v.$reset() })
          this.person.name = null
          this.getPersons()
        }
      })
      .catch((er) => {
        this.errors = er.data
        this.afterFailure(er)
      })
  },
  doDelete (p, idx) {
    this.loading = true
    this.$http.delete('/v1/dweller/guest/list/person/' + p.id)
    .then((data) => {
      this.getPersons()
    })
    .catch((er) => {
      this.errors = er.data
      this.afterFailure(er)
    })
  },
  getPersons () {
    this.$http.get('/v1/dweller/guest/list/person/' + this.person.dweller_guest_list_id)
    .then((data) => {
      if (data) {
        this.persons = data
        this.loading = false
      }
    })
    .catch((er) => {
      this.errors = er.data
      this.afterFailure(er)
    })
  },
  calcTime (end) {
    this.loading = false
    var a = moment(`${this.schedule.start_date}T${this.schedule.go_in}:00`)
    var b = moment(`${this.schedule.start_date}T${end}:00`)
    if (a.diff(b, 'minutes') === -60 || a.diff(b, 'minutes') === -31) {
      this.loading = true
      const timeLabelStart = find(this.timeOptions, {id: this.schedule.go_in})
      const timeLabelEnd = find(this.timeOptions, {id: end})
      const params = {
        common_area_id: this.schedule.common_area_id,
        go_in: `${this.schedule.start_date} ${timeLabelStart.label}`,
        go_out: `${this.schedule.start_date} ${timeLabelEnd.label}`
      }
      this.$http.post('/v1/dweller/schedules/check', params)
      .then((data) => {
        if (data[0].count >= '1') {
          this.$toast.error('Este Periodo não esta mais disponivel.')
          this.doHide()
        }
        this.loading = false
      })
      .catch((er) => {
        this.errors = er.data
        this.afterFailure(er)
      })
    } else {
      this.$toast.error('Periodo máximo de permanência 1hr.')
    }
    // console.log(moment().add(10, 'minutes').format('HH:mm'))
  },
  checkLimitDay (dt) {
    this.loading = true
    if (this.charge_for_hours) {
      const params = {
        unit_id: this.schedule.unit_id,
        common_area_id: this.schedule.common_area_id,
        go_in: `${dt} 00:01`,
        go_out: `${dt} 23:59`,
        charge_for_hours: this.charge_for_hours
      }

      this.$http.post('/v1/dweller/schedules/check/date', params)
      .then((data) => {
        if (data[0].count >= '1') {
          this.$toast.error('Esta Unidade já tem um agendamento para a data selecionada.')
          this.doHide()
        }
        this.loading = false
      })
      .catch((er) => {
        this.errors = er.data
        this.afterFailure(er)
      })
    } else {
      const params = {
        unit_id: this.schedule.unit_id,
        common_area_id: this.schedule.common_area_id,
        go_in: `${dt}`,
        go_out: `${dt}`,
        charge_for_hours: this.charge_for_hours
      }
      this.$http.post('/v1/dweller/schedules/check/date', params)
      .then((data) => {
        if (data[0].count >= '1') {
          this.$toast.error('Este horário nao esta mais disponivel.')
        }
        this.loading = false
      })
      .catch((er) => {
        this.errors = er.data
        this.afterFailure(er)
      })
    }
  },
  /** verificando se esta ainda disponivel */
  doSchedule (schedule) {
    this.loading = true
    this.schedule.id = schedule.id
    this.$http.post(`/v1/dweller/search/schedule/times/check`, {id: schedule.id})
    .then(({data}) => {
      if (data.length === 1) {
        this.$toast.error('Este horário não esta mais disponivel.')
        this.loading = false
      } else {
        // this.isShowing = true
        this.loading = false
        this.next()
      }
    })
    .catch((er) => {
      this.errors = er.data
    })
  },
  setCommomAreaId (area) {
    this.loading = true
    this.id_common_area = area
    this.scheduleTimes = []
    this.scheduleByDay = false
    this.availableDay = []
    this.isToday()

    Promise.all([
      this.getCommonAreaScheduled(area),
      this.getCommonAreaById(area)
    ])

    if (this.id_common_area !== null) {
      this.loading = false
    }
  },
  next () {
    this.back = false
    this.currentIndex++
  },
  prev () {
    this.back = true
    this.currentIndex--
    this.schedule = {
      id: null,
      event_name: null,
      title: null,
      start_date: null,
      end_date: null,
      tower_id: this.schedule.tower_id,
      unit_id: this.schedule.unit_id,
      dweller_guest_list_id: null,
      common_area_id: null,
      go_in: null,
      go_out: null
    }
  },
  prevRestart () {
    this.back = true
    this.currentIndex = 0
  },
  isFutureDate (date) {
    return date < new Date(Date.now() - (3600 * 1000 * 24))
  },
  isFutureDateMoreOne (date) {
    const currentDate = new Date()
    return date < currentDate
  },
  isToday () {
    let isNow = new Date()
    let month = isNow.getMonth() + 1
    let day = isNow.getDate()
    let today = isNow.getFullYear() + '-' + (('' + month).length < 2 ? '0' : '') + month + '-' + (('' + day).length < 2 ? '0' : '') + day
    this.schedule.start_date = today
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/resources/methods.js